import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Badge, Typography, useDevice } from 'seagull';
import { CopyToClipboard } from '~/components/CopyToClipboard/CopyToClipboard';
import { useLocaleKeys } from '~/i18n';
import styles from './CopyLinkForProposalModal.module.scss';
export const copyLinkTextsPath = 'hooks.copyLink';
export function getRecipientBadgeInfo(param, copyLinkTexts) {
    let { isSignatureRequired, hasSigned, isPrimary } = param;
    if (!isSignatureRequired) return null;
    if (hasSigned) return {
        text: copyLinkTexts.proposalModal.signed(),
        skin: 'success',
        badgeSkin: 'success'
    };
    else if (isPrimary) return {
        text: copyLinkTexts.proposalModal.primaryContact(),
        skin: 'disabled'
    };
    else return {
        text: copyLinkTexts.proposalModal.requiredToSign(),
        skin: 'disabled'
    };
}
function RecipientBadge(props) {
    const { t: copyLinkTexts } = useLocaleKeys(copyLinkTextsPath);
    const badgeInfo = getRecipientBadgeInfo(props, copyLinkTexts);
    return badgeInfo && /*#__PURE__*/ _jsx(Badge, {
        rounded: true,
        outlined: true,
        testId: props.testId,
        skin: badgeInfo.badgeSkin,
        children: /*#__PURE__*/ _jsx(Typography, {
            skin: badgeInfo.skin,
            variant: "paragraph2",
            children: badgeInfo.text
        })
    });
}
export function CopyLinkForProposalModal(props) {
    const { className, onClick, onError, onCopy, recipients, info, testId } = props;
    const { t: copyTexts } = useLocaleKeys('hooks.copyLink');
    const resolvedTestId = testId || 'copy-to-clipboard';
    const { isMobileDevice } = useDevice();
    const Recipient = (param)=>{
        let { recipient, isPrimary = false } = param;
        const { email, isSignatureRequired, hasSigned, notificationURL } = recipient;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.linkRow, {
                [styles.mobile]: isMobileDevice
            }),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.recipientDetails,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.reviewerDetails,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    ellipsis: true,
                                    variant: 'paragraph1',
                                    weight: 'normal',
                                    testId: 'recipient-name',
                                    children: recipient.fullName()
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    ellipsis: true,
                                    variant: 'paragraph2',
                                    weight: 'light',
                                    testId: 'recipient-email',
                                    children: email
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.badge,
                            children: /*#__PURE__*/ _jsx(RecipientBadge, {
                                isSignatureRequired: isSignatureRequired,
                                hasSigned: hasSigned,
                                isPrimary: isPrimary,
                                testId: "recipient-badge-".concat(email)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(CopyToClipboard, {
                    size: isMobileDevice ? 'small' : undefined,
                    value: notificationURL,
                    buttonLabel: copyTexts.copy(),
                    onClick: onClick,
                    onError: onError,
                    onCopy: onCopy,
                    buttonClassname: styles.button,
                    textfieldClassname: styles.link,
                    className: styles.linkWrapper
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.multipleRecipientsRoot, className),
        "data-testid": resolvedTestId,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                className: styles.title,
                children: copyTexts.linksAreUnique()
            }),
            info,
            /*#__PURE__*/ _jsxs("div", {
                className: styles.linksContainer,
                children: [
                    /*#__PURE__*/ _jsx(Recipient, {
                        recipient: recipients.primary,
                        isPrimary: true
                    }, recipients.primary.email),
                    recipients.additionalRecipients.length > 0 && /*#__PURE__*/ _jsx(Typography, {
                        className: styles.additionalRecipientsTitle,
                        children: copyTexts.additionalRecipients()
                    }),
                    recipients.additionalRecipients.map((recipient)=>/*#__PURE__*/ _jsx(Recipient, {
                            recipient: recipient
                        }, recipient.email))
                ]
            })
        ]
    });
}
